export const taskStatusData = [
  { id: 1, name: '启用' },
  { id: 0, name: '暂停' }
]
export const accountStatusData = [
  { id: 1, name: '启用中' },
  { id: 0, name: '已禁用' }
]

export const deductSwitchData = [
  { id: 1, name: '是' },
  { id: 0, name: '否' }
]

export const accountTypeData = [
  { id: 0, name: '普通账号' },
  { id: 1, name: '管家账号' }
]

export const whiteListData = [
  { id: 0, name: '是' },
  { id: 1, name: '否' }
]

export const modelPredictResultData = [
  { id: 1, name: '建议关停' },
  { id: 0, name: '建议持续投放' },
  { id: 2, name: '待定' },
  { id: 3, name: '未计算' }
]

export const dataModelData = [
  { name: '按名称1对1匹配', id: 1 },
  { name: '汇总合计1条计划', id: 2 }
]
